import { updateHandler } from "../utils";
export var getManageEndpoints = function (api) { return ({
    getSports: {
        providesTags: ["getSports"],
    },
    updateSport: {
        invalidatesTags: ["getPlaces", "getSports"],
        onQueryStarted: updateHandler("getSportById", "id", api),
    },
    createSport: {
        invalidatesTags: ["getSports"],
    },
    deleteSport: {
        invalidatesTags: ["getSports"],
    },
    getCities: {
        providesTags: ["getCities"],
    },
    updateCity: {
        invalidatesTags: ["getPlaces", "getCities"],
        onQueryStarted: updateHandler("getCityById", "id", api),
    },
    createCity: {
        invalidatesTags: ["getCities"],
    },
    deleteCity: {
        invalidatesTags: ["getCities"],
    },
}); };
